// @ts-check

import React, { useState } from "react";

import { Banner, BlockStack, Button, ButtonGroup, FormLayout, InlineStack, Text, TextField } from "@shopify/polaris";

import { useUtmLinks } from "context/UtmLinksContext";
import { useGlobalContext } from "context/GlobalContext";

export const CreateRegularUtmLink = () => {
  const {
    setError,
    baseUrl,
    setBaseUrl,
    utmSource,
    setUtmSource,
    utmMedium,
    setUtmMedium,
    utmCampaign,
    setUtmCampaign,
    utmContent,
    setUtmContent,
    utmTerm,
    setUtmTerm,
  } = useUtmLinks();
  const {
    refetchSavedUtmSets,
  } = useGlobalContext();

  const [loading, setLoading] = useState(false);

  const handleCreateClick = () => {
    setLoading(true);
    setError(null);

    return fetch("/api/utm-sets/saved", {
      method: "POST",
      body: JSON.stringify({
        domain: baseUrl,
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_campaign: utmCampaign,
        utm_content: utmContent,
        utm_term: utmTerm,
      }),
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then(({ error }) => {
        if (error) {
          throw new Error(error);
        }

        refetchSavedUtmSets();
      })
      .catch((error) => {
        setError(error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <BlockStack gap="400">
      <FormLayout>
        <Banner tone="info">
          <BlockStack gap="200">
            <Text as="p">
              Origin will automatically track all orders with UTM parameters set. You do not need to create them here.
            </Text>
            <Text as="p">
              This is just a useful helper to generate UTM links.
            </Text>
          </BlockStack>
        </Banner>
        <TextField
          label="Site Domain"
          value={baseUrl}
          onChange={setBaseUrl}
          placeholder="https://domain.com"
          helpText="The full URL for your domain (https://example.com)"
          autoComplete=""
        />

        <TextField
          label="Source"
          value={utmSource}
          onChange={setUtmSource}
          placeholder="Enter a custom value"
          helpText="Site source of the traffic (fb, ig, snapchat, email, etc.)"
          autoComplete=""
        />

        <TextField
          label="Medium"
          value={utmMedium}
          onChange={setUtmMedium}
          placeholder="Enter a custom value"
          helpText="Medium by which the traffic arrived (story, blog-post, facebook-feed, etc.)"
          autoComplete=""
        />

        <TextField
          label="Campaign"
          value={utmCampaign}
          onChange={setUtmCampaign}
          placeholder="Enter a custom value"
          helpText="Campaign attributed to this traffic (cyber-monday, black-friday, etc.)"
          autoComplete=""
        />

        <TextField
          label="Content (optional)"
          value={utmContent}
          onChange={setUtmContent}
          placeholder="Enter a custom value"
          helpText="Used to specify the content of the source. For Facebook ads, this could be the ad name"
          autoComplete=""
        />

        <TextField
          label="Term (optional)"
          value={utmTerm}
          onChange={setUtmTerm}
          placeholder="Enter a custom value"
          helpText="Arbitrary value that can be used for tracking whatever value you'd like"
          autoComplete=""
        />
      </FormLayout>

      <InlineStack align="end">
        <ButtonGroup>
          <Button
            disabled={
              !utmSource &&
              !utmMedium &&
              !utmCampaign &&
              !utmContent &&
              !utmTerm
            }
            variant="primary"
            onClick={handleCreateClick}
            loading={loading}
          >
            Save UTM Snippet
          </Button>
        </ButtonGroup>
      </InlineStack>
    </BlockStack>
  );
};
